import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDpDgState {
  isPlaying: boolean;
  playPosition: number;
}

const initialState: IDpDgState = {
  isPlaying: false,
  playPosition: 0,
};

export const dpdgStateSlice = createSlice({
  name: 'dpdgState',
  initialState,
  reducers: {
    setDpDgPosition: (state, action: PayloadAction<number>) => {
      state.playPosition = action.payload;
    },
    setDpDgPlay: (state) => {
      state.isPlaying = true;
    },
    setDpDgStop: (state) => {
      state.isPlaying = false;
    },
  },
});

export const { setDpDgPosition, setDpDgPlay, setDpDgStop } = dpdgStateSlice.actions;
export default dpdgStateSlice.reducer;
